export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.10.26-1422.20",
  commitId: "170345f1038950f9b457c86b08671e8de4d0c83b",
  commitTime: "2026-10-26T14:22:20.000Z",
});
